<template lang="pug">
  component.base-button(
    :is="tagName"
  ) {{text}}
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  export default defineNuxtComponent({
    name: 'BaseButton',
    props: {
      text: {
        type: String as PropType<string>,
        required: true,
      },
      tagName: {
        type: String as PropType<string>,
        default: 'button',
      },
    },
  });
</script>

<style lang="scss">
  :root {
    --base-button-height: 48px;
    --base-button-width: 100%;
  }
</style>
<style lang="scss" scoped>
  .base-button {
    @include fontTextBtn;

    background: var(--main-color);
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    width: var(--base-button-width);
    height: var(--base-button-height);
    cursor: pointer;
    text-decoration: none;

    @include hover {
      background: var(--hover-color);
    }
    &:disabled {
      cursor: default;
      opacity: 0.3;
    }
  }
</style>
